import { globalStyle, style } from '../layer.css.ts';
import { themeV2 } from '../theme-v2/vars.ts';
import { fonts, fontWeight, space } from '../tokens';

export const followersV2Count = style({
  textDecoration: 'none',
});

export const followersV2 = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: space.s8,
  height: 18,
  flexShrink: 0,
  fontFamily: fonts.mono,
  fontWeight: fontWeight.medium,
  fontSize: 12,
  lineHeight: 1.3,
  letterSpacing: '-0.04em',
  color: themeV2.color.text.secondary,
  whiteSpace: 'nowrap',
});

globalStyle(`.${followersV2} :where(svg)`, {
  width: 18,
  height: 18,
  flexShrink: 0,
});
